import config from "../../helper/config";
import APIHandler from "../../handlers/APIHandler";

export const roleService = {
  getById,
  getAll,
  getRolesForType,
  getAllRoles,
  addUserRole,
  updateUserRole,
  deleteUserRole,
  getRolesForType
};

async function getById(role_code) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(
      config.azure_ad_config.apis.OAT.name
    ),
  };
  const response = await fetch(`${config.oat_api_url}/user/roles/${role_code}`, requestOptions);
  return APIHandler.handleResponse(response);
}

async function getAll() {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(
      config.azure_ad_config.apis.OAT.name
    ),
  };
  return await fetch(`${config.oat_api_url}/user/roles/`, requestOptions).then(
    APIHandler.handleResponse
  );
}

async function getRolesForType(employeeType){
    const requestOptions = {
      method: "POST",
      headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      body: JSON.stringify(employeeType)
    };
    const response = await fetch(
      `${config.oat_api_url}/user/roles/rolenamelist`,
      requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllRoles(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/user/roles/getAllRoles/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addUserRole(newUserRole) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newUserRole),
    };

    const response = await fetch(
        `${config.oat_api_url}/user/roles/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateUserRole(roleItem, roleCode) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(roleItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/user/roles/update/${roleCode}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteUserRole(roleCode) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/user/roles/delete/${roleCode}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}



